module.exports = __webpack_public_path__ + "img/kh19.30236be1.png";